import React from "react";

function DropdownField({
  field,
  form,
  id = "dropdown-field",
  options = [],
  labelClassName = "",
  inputClassName = "",
  label,
  required = false,
  disabled = false,
  placeholder = "Select an option",
  placeholderFontSize = "text-[12px] text-[#B8A7AD]",
  onChange = () => {},
  errorForDropdown,
  placeholderFontFamily = "bold",
}) {
  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className={`block mt-6 mb-2 text-[1.2rem] text-[#4F2532] dark:text-[#4F2532] ${labelClassName}`}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <select
        id={id}
        className={`rounded-[10px] pl-3 block flex-1 font-[medium1] border-[1px] border-[#4F25321A] w-full h-full p-2.5 dark:text-[#4F2532] text-[#4F2532] placeholder:text-[#B8A7AD] focus-visible:outline-[#EFB6B6] ${placeholderFontSize} focus-visible:outline-none ${inputClassName}`}
        {...field}
        required={required}
        disabled={disabled}
        onChange={(e) => onChange(e)}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {form.touched[field.name] && (
        <div className="text-red-500 text-[12px] mt-2">
          {form.errors[field.name]}
          {errorForDropdown && "Required"}
        </div>
      )}
    </div>
  );
}

export default DropdownField;
